<template>
    <div class="tab-pane fade show active position-relative" id="assets">
        <div v-bind:class="{ open: uiStates.activeModal == 'assetEdit' }" class="slider-modal slider-image-modal">
            <div v-if="editAsset.assetType == 'image'" class="image-container" :style="{backgroundImage: `url('${editAsset.uri}')` }">
            </div>
            <transition name="vue-table-loader">
                <div class="vue-details-loader alt" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
            </transition>
            <transition name="fade">
                <div class="container"  v-if="uiStates.activeModal == 'assetEdit'">
                    <a v-on:click="cancelEditAsset()"  class="close-section">&times;</a>
                    <div class="slider-modal-copy" :style="{paddingTop: previewHeight + 'px' }">
                        <!-- <div v-if="editAsset.assetType == 'image'" class="thumbnail-large border" :class="{'has-thumb': editAsset.thumbnail}"
                        :style="{backgroundImage: `url('${editAsset.uri_internal}')` }">
                        </div> -->
                        <div class="row">
                            <div class="col-md-12">
                                <h3 style="margin-bottom: 0px;">Edit Asset</h3>
                                <p><small><strong>Path:</strong> {{editAsset.assetSource}}</small></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Version</label>
                                    <version-selector @versionSelectionChange="handleVersionSelectionChange" class="m-0" :show-label="false"></version-selector>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Name</label>
                                    <input v-model="versionedAsset.name" :disabled="uiStates.assetDrawerLoading" type="text" class="form-control" :name="editAsset.name" aria-describedby="helpId" placeholder="">
                                    <div v-if="versionedAsset.versionId != 0 && editAsset.name !== versionedAsset.name" class="versioned-asset__attribute-warning">
                                        <strong>Master value: {{ editAsset.name }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Description (alt-text)</label>
                                    <input v-model="versionedAsset.desc" :disabled="uiStates.assetDrawerLoading" type="textarea" class="form-control" :name="editAsset.name + 'description'" aria-describedby="helpId" placeholder="">
                                    <div v-if="versionedAsset.versionId != 0 && editAsset.desc !== versionedAsset.desc" class="versioned-asset__attribute-warning">
                                        <strong>Master value: {{ editAsset.desc }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="">Type</label>
                                    <input v-model="versionedAsset.type" :disabled="uiStates.assetDrawerLoading" type="textarea" class="form-control" :name="editAsset.name + 'type'" aria-describedby="helpId" placeholder="">
                                    <div v-if="versionedAsset.versionId != 0 && editAsset.type !== versionedAsset.type" class="versioned-asset__attribute-warning">
                                        <strong>Master value: {{ editAsset.type }}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <button type="button" class="btn btn-secondary" @click="cancelEditAsset()">Cancel</button>
                                <button type="button" :disabled="uiStates.assetDrawerLoading" class="btn btn-primary" @click="saveAsset(editAsset.id)">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-2">
                    <h3 class="pt-2 mb-2">Assets</h3>
                </div>
                <div class="col-md-10 text-right" v-if="$parent.permissionAllowed('manage_photography')">
                    <div class="d-flex justify-content-end align-items-start" :class="{'fade-container': selectedChannel != 0 }">
                        <button class="btn btn-primary mr-1" :disabled="selectedChannel != 0" @click="saveAssetOrder()">Save Asset Order</button>
                        <button class="btn btn-primary mr-1" :disabled="selectedChannel != 0" data-toggle="collapse" data-target="#asset_upload">Upload Asset</button>
                        <button class="btn btn-primary mr-1" :disabled="selectedChannel != 0" data-toggle="collapse" data-target="#create_asset">Add Asset by URL</button>
                        <delete-confirm label="Delete All Assets" :is-disabled="assetData.length == 0" @delete="handleDeleteAllAssets" ></delete-confirm>
                    </div>
                    <div v-if="selectedChannel != 0" class="channel-note">
                        * Assets can only be added and reordered on the default channel.
                    </div>
                </div>
            </div>
            <div class="row" v-if="$parent.permissionAllowed('manage_photography')">
                <div class="col-md-12">
                    <p class="text-muted mb-2" style="font-size: 0.8rem; max-width: 60ch;">
                        Assets can be configured on a per-product basis from this tab. Depending on user permissions
                        you may also be able to access the <a @click="checkAccess" href="/assets">Asset Manager</a> view, which enables more
                        in-depth control over assets.
                    </p>
                </div>
            </div>
            <div class="row p-0 m-0">
                <div class="col-md-12 d-flex flex-column px-0">
                    <label for="">Channel</label>
                    <div class="d-flex w-100">
                        <generic-tooltip style="display: grid; grid-template-columns: 1fr 3rem;"
                            :message="'Enables assets on a per-channel basis - the default value will sync  any changes to all channels'"
                        >
                            <channel-selector slot="tooltip_sibling" @channelSelectionChange="handleChannelSelectionChange" :product-id="$parent.product.info.id" :showLabel="false" class="p-0 m-0"></channel-selector>
                            <span slot="tooltip_trigger" class="d-flex align-items-center justify-content-center text-muted">
                                <i class="fas fa-info-circle"></i>
                            </span>
                        </generic-tooltip>
                    </div>
                </div>
            </div>
            <div class="row mb-4 mt-3" id="asset_forms">
                <div class="col-md-12">
                    <div id="create_asset" class="collapse border p-3" data-parent="#asset_forms">
                            <div class="form-group">
                                <label for="">New Asset URL</label>
                                <input type="text" name="asset_url" class="form-control" v-model="assetUploadUrl">
                            </div>
                            <div>
                                <input-checkbox v-model="uploadPrivate.value" :field-data="uploadPrivate" :skinnyMode="true" :hasBorder="false"></input-checkbox>
                                <input-checkbox v-model="uploadAsThumbnail.value" :field-data="uploadAsThumbnail" :skinnyMode="true" :hasBorder="false"></input-checkbox>
                            </div>
                        <div class="form-group">
                            <div class="col-md-12 text-right">
                                <button :disabled="assetUploadUrl === ''" @click="createAssetByUrl()" type="submit" class="btn btn-primary mt-3">Save</button>
                            </div>
                        </div>
                    </div>

                    <div id="asset_upload" class="collapse text-right border p-3 mt-3" data-parent="#asset_forms">
                        <vue-dropzone
                        @vdropzone-success="(file, response) => uploadSuccess(file, response)"
                        @vdropzone-files-added="updateFileUploadCount"
                        @vdropzone-file-added="updateFileUploadCount"
                        @vdropzone-removed-file="removeFile"
                        id="assetDropzone"
                        uploadMultiple="false"
                        acceptedFiles="image/*,application/pdf,.psd"
                        withCredentials="true"
                        ref="assetDropzone"
                        :useCustomSlot=true
                        :options="dropzoneOptions">
                        <div class="dropzone-custom-content">
                            <h3 class="dropzone-custom-title">Drop files here or click to upload</h3>
                        </div>
                        </vue-dropzone>
                        <div class="text-left ">
                            <input-checkbox v-model="uploadPrivate.value" :field-data="uploadPrivate" :skinnyMode="true" :hasBorder="false"></input-checkbox>
                            <input-checkbox v-model="uploadAsThumbnail.value" :field-data="uploadAsThumbnail" :skinnyMode="true" :hasBorder="false"></input-checkbox>
                        </div>

                        <button class="btn btn-primary mt-3" id="upload_continue_private" @click="uploadAssets()" disabled>Upload</button>
                    </div>
                </div>
            </div>
            <div class="assets-container" v-if="!uiStates.showLoading">
                <div class="dataTables_wrapper container-fluid dt-bootstrap4 mt-2">
                    <p v-if="assetData.length < 1">No Assets Found</p>
                    <table class="table table-middle table-minimal assets-table" v-else>
                        <thead>
                            <tr>
                                <th scope="col">Image</th>
                                <th scope="col">Product Asset Id</th>
                                <th scope="col">Path</th>
                                <th scope="col">Type</th>
                                <th scope="col">Enabled</th>
                                <th scope="col" class="text-right" v-if="$parent.permissionAllowed('manage_photography')">Action</th>
                            </tr>
                        </thead>
                        <draggable v-model="assetData" @start="drag=true" @end="drag=false" tag="tbody" :disabled="!$parent.permissionAllowed('manage_photography')">
                            <tr v-for="(asset, index) in assetData" :key="index">
                                <td scope="row">
                                    <a class="download-link" :href="asset.uri" download target="_blank">
                                        <div v-if="asset.assetType == 'image'" class="thumbnail-container border border-radius p-3" :style="{backgroundImage: `url('${asset.uri}')` }">
                                            <div v-if="asset.thumbnail" class="has-thumb">Thumbnail</div>
                                            <div v-if="!isAssetEnabled(asset)" class="is-disabled">Disabled</div>
                                        </div>
                                        <div v-else class="no-thumbnail-container border p-3" :class="{'has-thumb': asset.thumbnail}">
                                            <div v-if="!isAssetEnabled(asset)" class="is-disabled">Disabled</div>
                                        </div>
                                    </a>
                                </td>
                                <td scope="row">
                                    <div>{{asset.id}}</div>
                                </td>
                                <td scope="row">
                                    <div class="ellipsis">{{asset.assetSource}}</div>
                                </td>
                                <td>
                                    <div class="capitalize">{{asset.assetType}}</div>
                                </td>
                                <td>
                                    <div v-if="isAssetEnabled(asset)" class="">Yes</div>
                                    <div v-else class="">No</div>
                                </td>
                                <td class="text-right" v-if="$parent.permissionAllowed('manage_photography')">
                                    <div class="dropdown channel-tool-menu"  style="margin-left:5px;">
                                        <button type="button" class="btn btn-outline-primary " data-toggle="dropdown">
                                            <i class="fa fa-cog" aria-hidden="true"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right" id="batch_operation">
                                            <a v-if="selectedChannel == 0" @click="editAssetModal(asset)" class="dropdown-item">
                                                <span>Edit</span>
                                            </a>
                                            <a v-if="asset.assetType == 'image' && !asset.thumbnail" @click="setAsThumbnail(asset.id)" class="dropdown-item">
                                                Set As Thumbnail
                                            </a>
                                            <a class="dropdown-item" @click="toggleStatus(asset.id, isAssetEnabled(asset))">
                                                <span v-if="isAssetEnabled(asset)">Disable</span>
                                                <span v-else>Enabled</span>
                                            </a>
                                            <a v-if="selectedChannel != 0" class="dropdown-item" @click="resetToDefault(asset, selectedChannel)" >
                                                <span>Reset to default</span>
                                            </a>
                                            <a v-if="selectedChannel == 0" class="dropdown-item" @click="deleteAsset(asset.assetId)" >
                                                <span>Delete</span>
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                    <div class="assets-table__order-label" v-if="assetData.length && $parent.permissionAllowed('manage_photography')">
                        Click & drag items to rearrange asset order
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="editModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Asset</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="">Name</label>
                            <input v-model="editAsset.name" type="text" class="form-control"  aria-describedby="helpId" placeholder="">
                        </div>
                        <div class="form-group">
                            <label for="">Description</label>
                            <input v-model="editAsset.desc" type="textarea" class="form-control"  aria-describedby="helpId" placeholder="">
                        </div>
                        <div class="form-group">
                            <label for="">Type</label>
                            <input v-model="editAsset.type" type="textarea" class="form-control"  aria-describedby="helpId" placeholder="">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="saveAsset(editAsset.id)">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host;

import axios from 'axios';
import _ from "lodash";
import draggable from 'vuedraggable';

import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import FileUpload from '../form/form-file.vue';
import InputCheckbox from '../form/form-checkbox.vue';
import ChannelSelector from '../generic/channel-selector.vue';
import DeleteToggle from '../generic/delete-button-with-confirmation.vue';
import VersionSelector from '../generic/version-selector.vue';
import GenericTooltip from "../generic/generic-tooltip.vue";

export default {
    name: 'product-assets',
    components: {
        'file-upload': FileUpload,
        'input-checkbox': InputCheckbox,
        'channel-selector': ChannelSelector,
        'delete-confirm': DeleteToggle,
        'version-selector': VersionSelector,
        'generic-tooltip': GenericTooltip,
        vueDropzone: vue2Dropzone,
        draggable,
    },
    data() {
        return {
            selectedChannel: "0",
            previewHeight: null,
            uploadedFiles: [],
            uploadError: null,
            currentStatus: null,
            uploadFieldName: 'assets',
            vueDropzone: vue2Dropzone,
            // uploadPrivate: 0,
            uploadPrivate: {
                name: 'upload_private',
                label: 'Disable By Default?',
                required: false,
                type: 'checkbox',
                column: 'col-md-6',
                disabled: false,
                value: 0,
            },
            uploadAsThumbnail: {
                name: 'upload_as_thumb',
                label: 'Set as Thumbnail?',
                required: false,
                type: 'checkbox',
                column: 'col-md-6',
                disabled: false,
                value: 0,
            },
            assetData : [],
            uiStates: {
                activeModal: '',
                showLoading: true,
                assetDrawerLoading: false
            },
            editAsset: {},
            versionedAsset: {
                assetId: 0,
                versionId: 0,
                name: '',
                desc: '',
                type: ''
            },
            assetUploadUrl: '',
            formData: {},
            dropzoneOptions: {
                addRemoveLinks: true,
                url: base_url + '/pimapi/products/upload-asset',
                thumbnailWidth: 150,
                headers:  {'X-CSRF-Token': $('meta[name=csrf-token]').attr('content')},
                parallelUploads: 1,
                maxFilesize: 50

            }
        }
    },
    beforeMount() {
        if(this.$parent.productAssets) {
            this.uiStates.showLoading = false;
        }
    },
    mounted() {},
    created() {
        this.reset();
        this.loadAssets();
    },
    methods : {
        handleVersionSelectionChange(versionId) {
            this.uiStates.assetDrawerLoading = true;

            axios.get(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/assets/' + this.editAsset.id + '/versions/' + versionId)
            .then((response) => {
                this.versionedAsset.versionId = versionId;

                // if no response data fall back to master
                this.versionedAsset.name = response.data.name ? response.data.name : this.editAsset.name;
                this.versionedAsset.desc = response.data.desc ? response.data.desc : this.editAsset.desc;
                this.versionedAsset.type = response.data.type ? response.data.type : this.editAsset.type;
                this.versionedAsset.alttext = response.data.alttext ? response.data.alttext : this.editAsset.alttext;

                this.uiStates.assetDrawerLoading = false;
            })
            .catch((error) => {
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            });
        },
        updateFileUploadCount() {
            if (this.$refs.assetDropzone.dropzone.files.length > 1) {
                this.uploadAsThumbnail.disabled = true;
                this.uploadAsThumbnail.value = 0;

            } else {
                this.uploadAsThumbnail.disabled = false;
            }
        },
        removeFile(file) {
            axios.delete(base_url + '/pimapi/products/remove-asset',{ data: {'assetFile' : file.name}})
            .then(function(_res) {
                this.updateFileUploadCount();
            }.bind(this));
        },
        handleDeleteAllAssets() {
            axios.delete(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/delete-all-assets')
            .then(function(_res) {
                this.uiStates.showLoading = false;
                this.loadAssets();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = "Assets successfully Deleted";
            }.bind(this))
            .catch(function(err) {
                this.uiStates.showLoading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = err.response.data.message;
            }.bind(this))
        },
        isAssetEnabled(asset) {
            if (asset.enabled === 1) {
                return true;
            }
            if (asset.enabled === 0) {
                return false;
            }

            return asset.enabled;

        },
        handleChannelSelectionChange(newChannel) {
            if (newChannel != this.selectedChannel) {
                this.selectedChannel = newChannel;
                this.loadAssets();
            }
        },
        uploadSuccess(file, _res) {
            if(file.status == 'success'){
                $('#upload_continue_private').prop('disabled', false);
            }
        },
        reset() {
            this.uploadedFiles = [];
            this.uploadError = null;
        },
        uploadAssets() {
            this.uiStates.showLoading = true;
            axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/add-asset', {
                'assetData' : {
                    'private' : this.uploadAsPrivate,
                    'isThumbnail': this.uploadAsThumbnail.value
                }
            })
            .then(function(_res) {
                this.uiStates.showLoading = false;
                this.loadAssets();
                this.$parent.alert.status = _res.data.message ? "alert-warning" : "alert-success";
                this.$parent.alert.message = _res.data.message || "Asset successfully saved";
                this.$refs.assetDropzone.removeAllFiles();
                $('#asset_upload').collapse('toggle');
                this.uploadPrivate.value = false;
            }.bind(this))
            .catch(function(err) {
                this.uiStates.showLoading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = err.response.data.message;
                this.$refs.assetDropzone.removeAllFiles();
            }.bind(this))
        },
        openCreateAsset() {
            $('#asset_upload').collapse('toggle');
        },
        openCreateAssetUrl() {
            $('#create_asset').collapse('toggle');
        },
        loadAssets() {
            this.uiStates.showLoading = true;
            axios.get(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/channels/' + this.selectedChannel + '/assets', {

            })
            .then(function(response) {
                this.assetData = response.data.data;
                this.$parent.productAssets = this.data;
                this.$parent.loadedPanelData.assets = true;
                this.uiStates.showLoading = false;
            }.bind(this))
            .catch(function(error) {
                console.log(error);
            }.bind(this));
        },
        toggleStatus(id, state) {
            if (state == 1 || state == true) {
                state = false;
            } else {
                state = true;
            }
            axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/assets/' + id + '/channels/' + this.selectedChannel + '/status', {
                enabled: state
            })
            .then(function(_res) {
                this.loadAssets();
            }.bind(this))
            .catch(function(err) {
                console.log(err);
            }.bind(this));
        },
        setAsThumbnail(id) {
            axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/assets/' + id + '/channels/' + this.selectedChannel + '/thumbnail', {})
            .then(function(_res) {
                this.loadAssets();
                this.$parent.loadProductDetails();
            }.bind(this))
            .catch(function(err) {
                console.log(err);
            }.bind(this));
        },
        checkAccess(event) {
            if (!this.$parent.featureAllowed('dam')) {
                event.preventDefault();
                console.log("not allowed");
                this.$parent.alert.status = "alert-warning";
                this.$parent.alert.message = "Please contact your account management to get access to this feature";
            }
        },
        saveAsset(id) {
            this.uiStates.showLoading = true;
            this.uiStates.assetDrawerLoading = true;

            if (this.versionedAsset.versionId != 0) {
                this.uiStates.showLoading = true;
                this.uiStates.assetDrawerLoading = true;

                axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/assets/' + this.versionedAsset.assetId + '/versions/' + this.versionedAsset.versionId, {
                    'name': this.versionedAsset.name,
                    'desc': this.versionedAsset.desc,
                    'type': this.versionedAsset.type,
                    'alttext': this.versionedAsset.alttext,
                })
                .then(function(_res) {
                    this.loadAssets();
                    this.uiStates.showLoading = false;
                    this.uiStates.assetDrawerLoading = false;
                    this.cancelEditAsset();
                    this.$parent.alert.status = "alert-success";
                    this.$parent.alert.message = "Asset has successfully been updated!";
                }.bind(this))
                .catch(function(error) {
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = error.response.data.message;
                }.bind(this));
            } else {
                this.editAsset.name = this.versionedAsset.name;
                this.editAsset.desc = this.versionedAsset.desc;
                this.editAsset.type = this.versionedAsset.type;
                this.editAsset.alttext = this.versionedAsset.alttext;

                axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/asset-properties/' + id, {
                    'assetProperties' : this.editAsset
                })
                .then(function(_res) {
                    this.loadAssets();
                    this.uiStates.showLoading = false;
                    this.uiStates.assetDrawerLoading = false;
                    this.cancelEditAsset();
                    this.$parent.alert.status = "alert-success";
                    this.$parent.alert.message = "Asset has successfully been updated!";
                }.bind(this))
                .catch(function(error) {
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = error.response.data.message;
                }.bind(this));
            }
        },
        resetToDefault(asset, channelId) {
            this.uiStates.showLoading = true;
            axios.delete(base_url + '/pimapi/products/' + asset.productId + '/assets/' + asset.id + '/channels/' + channelId , {

            })
            .then(function(_res) {
                this.loadAssets();
                this.uiStates.showLoading = false;
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = "Asset has successfully reset!";
            }.bind(this))
            .catch(function(_err) {
                this.loadAssets();
                this.uiStates.showLoading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = "Asset could not be reset";
            }.bind(this));
        },
        deleteAsset(id) {
            this.uiStates.showLoading = true;
            axios.delete(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/remove-asset/' + id, {

            })
            .then(function(_res) {
                this.loadAssets();
                this.uiStates.showLoading = false;
            }.bind(this))
            .catch(function(err) {
                console.log(err);
            }.bind(this));
        },
        createAssetByUrl(){
            this.uiStates.showLoading = true;
            axios.post(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/add-asset', {
                'assetData' : {
                    'asset_url' : this.assetUploadUrl,
                    'isPrivate' : this.uploadPrivate.value,
                    'isThumbnail': this.uploadAsThumbnail.value
                }
            })
            .then(function(_res) {
                this.uiStates.showLoading = false;
                this.loadAssets();
                this.assetUploadUrl = '';
                this.uploadPrivate.value = 0;
                $('#create_asset').collapse('toggle');
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = "Asset has been uploaded successfully!";
            }.bind(this))
            .catch(function(err) {
                this.uiStates.showLoading = false;
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = err.response.data.message;
            }.bind(this));
        },
        saveAssetOrder() {
            this.uiStates.showLoading = true;
            axios.put(base_url + '/pimapi/products/'+ this.$parent.product.info.id + '/save-asset-order', {
                'assetData' : this.assetData
            })
            .then(function(_res) {
                this.uiStates.showLoading = false;
                this.loadAssets();
            }.bind(this))
            .catch(function(err) {
                this.uiStates.showLoading = false;
                console.log(err);
            }.bind(this));

        },
        editAssetModal(asset) {
            this.editAsset = asset;

            this.versionedAsset.desc = this.editAsset.desc;
            this.versionedAsset.name = this.editAsset.name;
            this.versionedAsset.type = this.editAsset.type;
            this.versionedAsset.alttext = this.editAsset.alttext;
            this.versionedAsset.assetId = this.editAsset.id;
            this.versionedAsset.versionId = 0;

            this.uiStates.activeModal = 'assetEdit';
        },
        cancelEditAsset() {
            this.uiStates.activeModal = '';
        },
    },
    computed: {
        uploadAsPrivate() {
            if (this.uploadPrivate.value == 1) {
                return 1;
            } else {
                return 0;
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .channel-note {
        font-size: .8em;
        margin-top: 7px;
    }
    .fade-container {
        opacity: 0.5;
    }
    .vue-dropzone{
        border: 1px dashed  #DEDEDE;
    }
    .product-form-tab{
        min-height: 500px;
    }
    figure {
        margin: 0;
        img {
            width: 100px;
            height: 100px;
        }
        i {
            font-size: 100px;
            height: 100px;
        }
    }
    .thumbnail-container{
        position: relative;
        width: 100px;
        height: 100px;
        background-size: cover;
        background-position: center;

        .has-thumb{
                content: "Thumbnail";
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 1;
                left: 0;
                width: 100%;
                bottom: 0px;
                background-color: rgba(0, 178, 217, 0.82);
                padding: 3px;
                color: #fff;
                font-size: 10px;
        }
        .is-disabled{
                content: "Disabled";
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 1;
                left: 0;
                width: 100%;
                bottom: 36px;
                background-color: rgba(217, 0, 0, 0.82);
                padding: 3px;
                color: #fff;
                font-size: 10px;
        }
        &:after{
            transition: opacity 0.2s linear;
            opacity:0;
            cursor:pointer;
            position: absolute;
            content: "\F1BD";
            z-index:2;
            top:0;
            bottom:0;
            left:0;
            right:0;
            font: normal normal normal 22px/1 "LineAwesome";
            padding: 39px;
            color:white;
            text-align: center;
            background-color: rgba(0,0,0,0.5);
        }
        &:hover{
            &:after{
                transition: opacity 0.2s linear;
                opacity:1;
            }
        }
    }

    .no-thumbnail-container{
        position: relative;
        width: 100px;
        height: 100px;
        &:before{
            content: "\F1DF";
            position: absolute;
            top:0;
            bottom:0;
            left:0;
            right:0;
            font: normal normal normal 34px/1 "LineAwesome";
            padding: 32px;
            text-align: center;
            color: #8f8f8f;
        }
        &:after{
            transition: opacity 0.2s linear;
            opacity:0;
            cursor:pointer;
            position: absolute;
            content: "\F1BD";
            z-index:2;
            top:0;
            bottom:0;
            left:0;
            right:0;
            font: normal normal normal 22px/1 "LineAwesome";
            padding: 39px;
            color:white;
            text-align: center;
            background-color: rgba(0,0,0,0.5);
        }
        &:hover{
            &:after{
                transition: opacity 0.2s linear;
                opacity:1;
            }
        }

        .is-disabled {
            content: "Disabled";
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;
            left: 0;
            width: 100%;
            bottom: 36px;
            background-color: rgba(217, 0, 0, 0.82);
            padding: 3px;
            color: #fff;
            font-size: 10px;
        }
    }
    .product-asset {
        .btn-group {
            display: flex;
            .btn {
                color: #BABABA;
                border-color: darken(#BABABA, 10%);
                flex: 1;
            }
        }
    }
    .ellipsis {
        width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }

    #assetDropzone > .dz-image {
        z-index: 1 !important;
    }

    .dropzone .dz-preview .dz-image {
        border-radius: 0;
        width: 100%;
        height: 100%;
        z-index: 1 !important;
    }

    .dropzone .dz-preview {
        width: 150px;
    }

    .vue-dropzone>.dz-preview .dz-remove {
        margin-right: 15px !important;
        margin-left: 15px !important;
    }

    .dropzone.dz-started {
        text-align: left;
    }
    .download-link{
        display: block;
    }
    .capitalize{
        text-transform: capitalize;
    }
    .slider-image-modal{
        .slider-modal-copy{
            padding: 260px 15px 30px 15px !important;
        }
        .image-container{
            position: absolute;
            top: 25px;
            left: 0px;
            right: 0px;
            width: 100%;
            height: 275px;
            background-size: auto 100%;
            background-position: center;
            background-repeat: no-repeat;
            border-bottom: 1px solid #dedede;
            background-color: #000;
        }
        .close-section{
            color:#fff !important;
            text-shadow: 0px 0px 4px #000 !important;
        }
        .vue-details-loader.alt{
            padding-top: 6px !important;
            position: fixed !important;
            width: 448px !important;
            left: auto !important;
            top: 360px !important;
        }
    }

    .assets-table {
        tr {
            cursor: grab;
        }

        tr:active {
            background: #dedede;
        }
    }

    .assets-table__order-label {
        padding: 10px 0 0;
    }

    .versioned-asset__attribute-warning {
        color: rgb(171, 87, 85);
        margin: 3px 0 0;
    }
</style>
<style lang="scss">
    // it seems like the scoped <style> tag above is trying to override a number of <vue-dropzone>
    // styles in addition to the base component styles. for whatever reason, in some cases, it
    // loses a specificity war against some of the <vue-dropzone> inline styles but not others.
    // to avoid breaking things further, rather than un-scoping the above entirely, or editing dropzone.scss
    // directly, <vue-dropzone> style overrides should go below:
    .vue-dropzone {
        .dz-preview {
            width: 160px;
            height: 160px;
            margin: 0;

            .dz-image {
                z-index: 1;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }
    }
</style>
